import $ from 'jquery';

$(function () {
    if (window.location.pathname == '/' && window.location.hash == '#footer') {
        window.location = '/contact-us/'
    }
    $('a').each(function (ind, elem) {
        var link = $(elem);
        if (link.attr('href').indexOf('/#footer') >= 0) {
            link.attr('href', '/contact-us/');
        }
    })
    $(window).on('hashchange', function () {
        if (window.location.pathname == '/' && window.location.hash == '#footer') {
            window.location = '/contact-us/'
        }
    })
});